import React, { useState } from 'react';
import { MapPin, Clock, IndianRupee, Briefcase } from 'lucide-react';
import JobApplicationPopup from '../JobApplicationPopup';

const OpenPositions = ({ className = "" }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);

  const handleApplyClick = (position) => {
    setSelectedPosition(position);
    setIsPopupOpen(true);
  };

  const positions = [
    {
      title: "Project Manager",
      location: "Calicut",
      type: "Full-time",
      experience: "5+ years",
      salary: "Competitive",
      description: "Lead projects, manage teams, and ensure timely completion while maintaining quality standards.",
      requirements: ["Strong leadership skills", "Project management experience", "Excellent communication"]
    },
    {
      title: "Civil Engineer",
      location: "Calicut",
      type: "Full-time",
      experience: "2+ years",
      salary: "Competitive",
      description: "Design, supervise, and manage civil construction projects ensuring safety and quality.",
      requirements: ["Site management experience", "Analytical skills", "Problem-solving ability"]
    },
    {
      title: "Site Engineer",
      location: "Calicut",
      type: "Full-time",
      experience: "5+ years",
      salary: "Competitive",
      description: "Oversee daily site operations, manage resources, and ensure compliance with construction standards.",
      requirements: ["Site management experience", "Technical knowledge", "Problem-solving skills"]
    },
    {
      title: "Draftman Civil",
      location: "Calicut",
      type: "Full-time",
      experience: "5+ years",
      salary: "Competitive",
      description: "Prepare detailed civil engineering drawings and assist engineers in project planning.",
      requirements: ["Proficient in CAD software", "Attention to detail", "Knowledge of construction drawings"]
    },
    {
      title: "Marketing Manager",
      location: "Calicut",
      type: "Full-time",
      experience: "5+ years",
      salary: "Competitive",
      description: "Plan and execute marketing strategies to promote projects and increase brand visibility.",
      requirements: ["Marketing strategy experience", "Team leadership", "Communication skills"]
    },
    {
      title: "Marketing Officer",
      location: "Calicut",
      type: "Full-time",
      experience: "2+ years",
      salary: "Competitive",
      description: "Assist in marketing campaigns, handle promotions, and support the marketing manager.",
      requirements: ["Good communication skills", "Marketing knowledge", "Team player"]
    },
    {
      title: "Customer Relation Executive",
      location: "Calicut",
      type: "Full-time",
      experience: "2+ years",
      salary: "Competitive",
      description: "Handle customer queries, maintain strong client relationships, and ensure customer satisfaction.",
      requirements: ["Communication skills", "Problem-solving ability", "Customer-focused mindset"]
    }
  ];

  return (
    <div id="open-positions" className={`pt-20 pb-14 sm:pb-20 bg-gray-50 ${className}`}>
      <div className="max-w-7xl mx-auto px-3 sm:px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-full text-[var(--primarycolor)] text-sm font-medium mb-8 border border-red-100">
            <Briefcase className="w-4 h-4" />
            Current Openings
          </div>
          
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-tight">
            Join Our 
            <span className="block text-[var(--primarycolor)] font-normal">Growing Team</span>
          </h2>
        </div>

        {/* Positions Grid */}
        <div className="grid lg:grid-cols-2 gap-8">
          {positions.map((position, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 border border-gray-200 hover:border-red-300 transition-all duration-300 group">
              {/* Header */}
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-2xl font-semibold text-gray-900 mb-2 group-hover:text-[var(--primarycolor)] transition-colors">
                  {position.title}
                </h3>
              </div>

              {/* Details */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="flex items-center gap-2 text-gray-600">
                  <MapPin className="w-4 h-4" />
                  <span className="text-sm">{position.location}</span>
                </div>
                <div className="flex items-center gap-2 text-gray-600">
                  <Clock className="w-4 h-4" />
                  <span className="text-sm">{position.type}</span>
                </div>
                <div className="flex items-center gap-2 text-gray-600">
                  <Briefcase className="w-4 h-4" />
                  <span className="text-sm">{position.experience}</span>
                </div>
                <div className="flex items-center gap-2 text-gray-600">
                  <IndianRupee className="w-4 h-4" />
                  <span className="text-sm">{position.salary}</span>
                </div>
              </div>

              {/* Description */}
              <p className="text-gray-600 mb-6 leading-relaxed">
                {position.description}
              </p>

              {/* Requirements */}
              <div className="mb-6">
                <h4 className="font-semibold text-gray-900 mb-3">Requirements:</h4>
                <ul className="space-y-2">
                  {position.requirements.map((req, reqIndex) => (
                    <li key={reqIndex} className="flex items-center gap-3 text-gray-600">
                      <div className="w-1.5 h-1.5 bg-red-500 rounded-full"></div>
                      {req}
                    </li>
                  ))}
                </ul>
              </div>

              {/* CTA */}
              <button 
                onClick={() => handleApplyClick(position)}
                className="w-full bg-[var(--primarycolor)] hover:bg-red-900 text-white py-3 px-6 rounded-xl font-semibold transition-all duration-300"
              >
                Apply Now
              </button>
            </div>
          ))}
        </div>

        {/* Job Application Popup */}
        <JobApplicationPopup 
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          position={selectedPosition}
        />
      </div>
    </div>
  );
};

export default OpenPositions;